<!--
 * @Description:
 * @Author: -898-
 * @Date: 2025-01-07 16:00:18
 * @LastEditTime: 2025-01-07 16:07:58
 * @LastEditors: -898-
-->
<template>
  <div class="common-title-box" :style="boxStyle">
    <span>{{ title }}</span>
  </div>
</template>
<script>
export default {
  name: "CommonTitle",
  props: {
    title: {
      type: String,
      default: "",
    },
    boxStyle: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.common-title-box {
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  &::before {
    content: "";
    display: inline-block;
    width: 4px;
    height: 16px;
    background: #3177ff;
  }
  span {
    font-weight: 600;
    font-size: 14px;
    color: #333333;
    line-height: 20px;
    padding-left: 12px;
  }
}
</style>
